import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { forexApi, type AccountExecutionIssue } from "@/lib/forex-api";

export default function AccountExecutionIssuesTab({ terminalOnly = false }: { terminalOnly?: boolean }) {
  const [issues, setIssues] = useState<AccountExecutionIssue[]>([]);
  const [cursor, setCursor] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [revision, setRevision] = useState(0);
  const [query, setQuery] = useState("");
  useEffect(() => {
    let active = true;
    setLoading(true);
    setError("");
    forexApi.listAccountExecutionIssues(undefined, terminalOnly).then((page) => {
      if (active) { setIssues(page.items); setCursor(page.next_cursor); }
    }).catch(() => { if (active) setError("账号执行异常暂不可用，请重试"); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [revision, terminalOnly]);
  const more = async () => {
    if (!cursor || loading) return;
    setLoading(true); setError("");
    try {
      const page = await forexApi.listAccountExecutionIssues(cursor, terminalOnly);
      setIssues((previous) => [...previous, ...page.items]);
      setCursor(page.next_cursor);
    } catch { setError("下一页异常加载失败，请重试"); }
    finally { setLoading(false); }
  };
  const visible = issues.filter(issue => !query.trim() || `${issue.account_scope} ${issue.reason_code || ""} ${issue.command_id || ""} ${issue.signal_id} ${issue.issue_id}`.toLowerCase().includes(query.trim().toLowerCase()));
  return <div className="space-y-4">
    <div><h2 className="text-lg font-semibold">{terminalOnly ? "Terminal 执行异常" : "账号执行异常"}</h2>
      <p className="text-sm text-text-muted">展示账号目标阻断、命令失败与待核对事实；状态只能由新的执行或核对结果改变。</p></div>
    <div className="flex flex-wrap items-center gap-2"><input aria-label="查找已加载异常" value={query} onChange={event => setQuery(event.target.value)} placeholder="账号、原因或编号" className="rounded border px-3 py-2 text-sm" /><button type="button" onClick={() => setRevision(value => value + 1)} className="rounded border px-3 py-2 text-sm">刷新</button><span className="text-xs text-text-muted">已加载 {issues.length} 条 · 当前显示 {visible.length} 条{cursor ? " · 仍有后续页" : ""}；查找仅覆盖已加载项</span></div>
    {error && <div role="alert" className="text-sm text-red-600">{error} <button onClick={() => cursor ? void more() : setRevision((value) => value + 1)}>重试</button></div>}
    {loading && <p>加载中...</p>}
    {!loading && !error && visible.length === 0 && <p>{issues.length ? "已加载异常中没有符合条件的记录" : "暂无账号执行异常"}</p>}
    {!!visible.length && <div className="overflow-x-auto"><table className="w-full text-sm"><thead><tr className="border-b text-left">
      <th className="p-3">发生时间 / 对象</th><th className="p-3">账号 / 品种</th><th className="p-3">状态 / 原因</th><th className="p-3">订单影响</th><th className="p-3">核对</th>
    </tr></thead><tbody>{visible.map((issue) => <tr key={issue.issue_id} className="border-b">
      <td className="p-3 text-xs">{new Date(issue.created_at * 1000).toLocaleString("zh-CN")}<div className="font-mono">{issue.issue_id}</div></td>
      <td className="p-3">{issue.account_role === "platform_master" ? "平台主账号" : "用户子账号"} · {issue.account_scope}<div>{issue.symbol}</div></td>
      <td className="p-3">{issue.state}<div className="text-xs text-text-muted">{issue.reason_code || "未提供"}</div></td>
      <td className="p-3">{issue.result_phase || "无回报"} / {issue.order_effect || "未确认"}</td>
      <td className="p-3">{issue.command_id
        ? <Link className="text-brand underline" to={`/forex/account-commands/detail?id=${encodeURIComponent(issue.command_id)}`}>查看账号命令</Link>
        : <Link className="text-brand underline" to={`/forex/execution-detail/detail?id=${encodeURIComponent(issue.signal_id)}`}>查看共享信号</Link>}</td>
    </tr>)}</tbody></table></div>}
    {cursor && <button disabled={loading} onClick={() => void more()} className="rounded border px-3 py-2 text-sm">加载更多</button>}
  </div>;
}
